// REACT
import React from "react";

// MATERIAL-UI
import { Grid, Typography, IconButton } from "@mui/material";

// COMPONENTS
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";

// ASSESTS
import ModalTitleProps from "src/components/wallets/common/types/modalHeaderTypes";
import { ModalHeaderStyles } from "src/components/wallets/common/styles/ModalHeader.styles";
import CrossIcon from "src/icons/CrossIcon";
import formatCoinName from "src/utils/formatCoinName";

const ModalHeader = (props: ModalTitleProps) => {
  const { logoUrl, code, name, onClose } = props.data;

  const classes = ModalHeaderStyles();

  return (
    <Grid
      item
      xs={12}
      container
      alignItems="center"
      justifyContent="center"
      className={classes.header}
    >
      <Grid item container justifyContent="space-between" alignItems="center">
        {/* ICON AND COIN CONTAINER */}
        <Grid
          item
          xs={10}
          md={10}
          justifyContent="center"
          alignItems="center"
          container
          className={classes.titleContainer}
        >
          {logoUrl && (
            <Grid item className={classes.iconItem}>
              <CountryOrCryptoFlag name={logoUrl || code} size={40} />
            </Grid>
          )}

          {name && (
            <Grid item>
              <Typography className={classes.title}>
                <b>{formatCoinName(name, true)}</b>
              </Typography>
            </Grid>
          )}
        </Grid>

        {/* CLOSE BUTTON */}
        <Grid
          item
          xs={1}
          md={2}
          container
          justifyContent="flex-end"
          className={classes.closeButton}
          onClick={onClose}
        >
          <IconButton>
            <CrossIcon color="#ffffff" />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalHeader;
